import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';

interface Claim {
  id: string;
  content: string;
  normalized_content: string;
  claim_type: string;
  confidence_score: number;
  importance_score: number;
  is_novel: number;
  attributed_to: string | null;
  entity_ids: string;
  event_date: string | null;
  story_id: string;
  source_texts: string | null; // JSON array of source text snippets
  metadata: string | null; // JSON with source_text and other extraction metadata
}

interface Quote {
  id: string;
  material_id: string;
  speaker_name: string;
  speaker_title: string | null;
  content: string;
  normalized_content: string;
  is_direct: number;
  source_type: string;
  context: string | null;
  is_novel: number;
  story_id: string;
}

interface Material {
  id: string;
  url: string;
  title: string;
  raw_content: string;
  author: string | null;
  published_at: string | null;
  scraped_at: string;
  word_count: number;
  extraction_status: string;
  story_id: string | null;
  source_name: string;
  source_slug: string;
  story_title: string | null;
  story_slug: string | null;
  claims: Claim[];
  quotes: Quote[];
}

export function useMaterial(materialId: string) {
  return useQuery({
    queryKey: ['material', materialId],
    queryFn: async () => {
      return apiClient.get<Material>(`/materials/${materialId}`);
    },
    enabled: !!materialId,
  });
}
